import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

export default function DocsPage() {
  return (
    <Box as="main" p={8} maxW="100%" mx="auto">
      <Heading size="lg" mb={4}>Documentation</Heading>
      <Text color="gray.400">Documentation coming soon.</Text>
    </Box>
  );
}
